import React, { useState, useEffect } from "react";

import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

export default function AlertDialog({
  showAlertDialog,
  setShowAlertDialog,
  submitHandler,
  text,
}) {
  const [open, setOpen] = React.useState(false);
  const [saveDetailsLoading, setDetailsSaveLoading] = useState(false);

  useEffect(() => {
    if (showAlertDialog === true) {
      setOpen(showAlertDialog);
    }
  }, []);

  const handleClose = () => {
    setOpen(false);
    setShowAlertDialog(false);
  };
  const submitHandlerInAlert = async () => {
    try {
      setDetailsSaveLoading(true);
      await submitHandler();
      setDetailsSaveLoading(false);
      handleClose();
    } catch (err) {
      console.error(err);
    } finally {
      setDetailsSaveLoading(false);
    }
  };

  return (
    <div>
      {/* <Button variant="outlined" onClick={handleClickOpen}>
      
      </Button> */}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{ fontWeight: "700" }}>
          Confirmation
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {text}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Later</Button>
          <Button
            variant="contained"
            onClick={() => {
              submitHandlerInAlert();
            }}
            autoFocus
          >
            Submit
            {saveDetailsLoading && (
              <CircularProgress
                style={{
                  width: "22px",
                  height: "22px",
                  marginLeft: "5px",
                }}
                color="inherit"
              />
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
